// global
import React from 'react';
import PropTypes from 'prop-types';
// components
import DefaultButton from 'app/components/commons/button/defaultButton/DefaultButton';
// consts
import { COLORS } from 'app/config/colors';

function ClearButton({ onClick, disabled }) {
  return (
    <DefaultButton
      tag={<u>LIMPAR</u>}
      size='small'
      onClick={onClick}
      color={COLORS.PRIMARY_VARIANT_DARK}
      colorHover={COLORS.PRIMARY_VARIANT_DARK}
      backgroundColor={COLORS.TRANSPARENT}
      backgroundColorHover={COLORS.SECONDARY_VARIANT_MEDIUM}
      borderColor={COLORS.TRANSPARENT}
      borderColorHover={COLORS.SECONDARY_VARIANT_MEDIUM}
      disabled={disabled}
    />
  );
}

ClearButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default ClearButton;
